import {
  observable,
  action,
  computed
} from "mobx";
import {
  post, get
} from "../services/ajax.service";
import MarketCheckData from "../MarketCheckData";
import { get_discount_key, get_rebate_key } from "../views2/dashboard/MarketCheck/MarketTiles/switch_contract_keys";



class MarketCheckStore {
  @observable change = false;
  @observable pbm = [];
  @observable toggle = false;
  @observable temp_pbm = [];
  @observable reportError = "";
  @observable delete_dropdown = false;
  @observable annualize_toggle = false;
  @observable delete_contract_dropdown = [];
  @observable pbm_categories = [];
  @observable pbm_contract_reArrange_Value = {};
  @observable runids_groups = [];
  @observable marketcheckdata = MarketCheckData.MarketCheckData;
  @observable url = "/api/v1/marketcheckactions";
  @observable formulary_participant_count = 0;
  @observable formulary_claims_count = 0;
  @observable formulary_participant = [];
  @observable excluded_claims = [];
  @observable excluded_claims_count = 0;
  @observable current_pbm_rebates = [];
  @observable current_pbm_discount = [];
  @observable current_pbm_check = "";
  @observable current_awp = 0
  @observable participant_count = 0
  @observable net_of_rebate = 0
  @observable each_change = false
  @observable change_detect = false
  @observable title_change = false
  @observable current_pbm_json = {}
  @observable current_pbm_json_from_load = {}
  @observable original_values = {}
  @observable change_in_card_detect = [];
  @observable contract_exclusion = [];
  @observable comparison_index = 0;
  @observable current_pbm_awp = 0;
  @observable custom_contract_name = "";
  @observable contract_name_status = false;




  @action change_comparison_index = (index) => {
    this.comparison_index = index
  }

  @action set_custom_contract_name = (value) => {
    this.custom_contract_name = value
  }

  @action set_custom_contract_name_status = (value) => {
    this.contract_name_status = value
  }

  @action set_dispensing_fee = (index,e) => {
    this.toggle_change();
    this.change_in_card_detect[index] = true
    const pbm_to_check = JSON.parse(JSON.stringify(this.pbm[index]))
    pbm_to_check[pbm_to_check.use_contracted ? "contracted_dispensing_fee" : "effective_dispensing_fee"] =e
    this.pbm[index] = pbm_to_check
  }

  @action set_current_effective_rebates = (index,e) => {
    this.toggle_change();
    this.change_in_card_detect[index] = true
    const pbm_to_check = JSON.parse(JSON.stringify(this.pbm[index]))
    pbm_to_check["current_effective_rebates"] =e
    this.pbm[index] = pbm_to_check

  }
  @action toggle_contracted_effective = (index,toggle) => {
    const pbm_to_check = JSON.parse(JSON.stringify(this.pbm[index]))
    pbm_to_check.use_contracted = toggle
    this.pbm[index] = pbm_to_check
  }
  @computed get tiles() {
    return parseInt(this.excluded_claims_count / 100) > 0 ? parseInt(this.excluded_claims_count / 100) + 1 : 0;
  }

  @action set_change_in_card_as_empty = () => {
    this.change_in_card_detect = []
  }

  @action set_current_pbm_json_from_load = value => {
    this.current_pbm_json_from_load = value;
  }
  @action set_current_pbm_json = value => {
    this.change = true;
    this.current_pbm_json = value;
  }
  @action set_toggle = value => {
    this.toggle = value;
  }
  @action set_current_awp = value => {
    this.current_awp = value
  }
  @action annual_toggle = value => {
    this.annualize_toggle = value;
  }

  @action getNet_of_rebate = categories => {
    let data = JSON.parse(categories)
    this.net_of_rebate = 0;
    if (data.length > 0) {
      this.net_of_rebate = data.reduce(
        (previousValue, currentValue) => parseFloat(previousValue) + parseFloat(currentValue.rebate),
        0
      );
    }
    return this.net_of_rebate.toFixed(2);
  }
  @action setCurrentPBM = (discount, rebate, check) => {
    this.current_pbm_discount = discount;
    this.current_pbm_rebates = rebate;
    this.current_pbm_check = check;
  }


  @action getTotalCount = async data => {
    this.participant_count = 0;
    try {
      let response = await post(
        `/api/v1/dataactions/participants/getTotalCount`,
        data
      );

      this.participant_count = response.data[0].participant_count;
    } catch (err) {
      console.log(err);
    }
  };


  @action get_formulary_participant_count = async data => {
    this.formulary_participant_count = 0;
    try {
      let response = await post(
        `${this.url}/get_formulary_participant_count`,
        data
      );
      this.formulary_participant_count = response.data[0].participants
    } catch (err) {
      console.log(err);
    }
  }
  @action get_formulary_claim_count = async data => {
    this.formulary_claims_count = 0;
    try {
      let response = await post(
        `${this.url}/get_formulary_claim_count`,
        data
      );
      this.formulary_claims_count = response.data[0].claims
    } catch (err) {
      console.log(err);
    }
  }
  @action get_formulary_participants = async data => {
    this.formulary_participant = [];
    try {
      let response = await post(
        `${this.url}/get_formulary_participants`,
        data
      );
      this.formulary_participant = response.data;
    } catch (err) {
      console.log(err);
    }
  }


  @action get_excluded_claims = async data => {
    this.excluded_claims = [];
    try {
      let response = await post(
        `${this.url}/get_excluded_claims`,
        data
      );
      this.excluded_claims = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getExcludedClaimsCount = async data => {
    try {
      let response = await post(
        `${this.url}/getExcludedClaimsCount`,
        data
      );
      this.excluded_claims_count = response.data[0].excluded_claim_count;
    } catch (err) {
      console.log(err);
    }
  }

  @action getCategoryRebate(index, category_name) {
    const pbm_to_check = JSON.parse(JSON.stringify(this.pbm[index]))
    const category = pbm_to_check[pbm_to_check.use_contracted ? "categories" : "effective_categories"][0];
    let rebate;
    switch (category_name) {
      case "RB30":
      case "RG30":
        rebate = category["retail_30_rebate"]
      case "RB90":
      case "RG90":
        rebate = category["retail_90_rebate"]
      case "S":
        rebate = category["specialty_rebate"]
      case "MB30":
      case "MB90":
      case "MG30":
      case "MG90":
        rebate = category["mail_order_rebate"]
    }

    return parseFloat(rebate);
  }

  @action toggle_change(change = true) {
    this.change = change
    this.toggle_each_change(true)
  }
  @action toggle_each_change(change) {
    this.each_change = change
  }
  @action setPBM_from_saved_contract(data) {
    this.pbm = [];
    this.pbm = data;
    this.change_in_card_detect=[];
    let card_detect=[];

    for (const iterator of data) {
      card_detect.push(this.isChangeDetectCurrentPBM(iterator))
    }

    this.change_in_card_detect=card_detect;
  }
  @action setPBM_Contract_data(data) {
    this.pbm_contract_reArrange_Value = data;
  }

  checkSteric=(obj,key)=>{
    let str=false;
    let aa= obj?.original_data?.categories?.find((d,i)=>{
        if(d?.category==obj?.categories[i]?.category && d[key]!=obj?.categories[i][key]){
            str=true;
            return str;
        }
    });
    return str;
}

  isChangeDetectCurrentPBM=(data)=>{

    if(data?.effective_dispensing_fee!=data?.original_data?.effective_dispensing_fee) return true;

    if((this.checkSteric(data,"ACTUAL_DISCOUNT") || this.checkSteric(data,"effective_rebate"))) return true;

    if((this.checkSteric(data,"discount") || this.checkSteric(data,"rebate"))) return true;

    if(((data?.pma_credit != data?.original_data?.pma_credit) || (data?.admin_fee != data?.original_data?.admin_fee))) return true;

    if(((data?.effective_admin_fee != data?.original_data?.effective_admin_fee) || (data?.effective_pma_credit != data?.original_data?.effective_pma_credit))) return true;

    return false;
}

  getSavedContractObjectReturn = (index) => {
    let object = { contract_id: "", pma: "", admin: "", categories: [], effective_categories: [] }
    object.contract_id = this.pbm[index].contract_id;
    object.pma = this.pbm[index].pma_credit;
    object.admin = this.pbm[index].admin_fee
    const use_contracted = this.pbm[index].use_contracted
    this.pbm[index][use_contracted ? "categories": "effective_categories"].map((d) => {
      object[use_contracted ? "categories": "effective_categories"].push({ category: d.category, discount: d.discount, rebate: d.rebate })
    })
    return object;
  }

  @action saveContractData = (index, inflation, emp_cost_share) => {

    //Inflation and Employment cost Share Saved In localstorage
    if (inflation > 0) {
      localStorage.setItem("inflation", inflation)
    }
    if (emp_cost_share > 0) {
      localStorage.setItem("emp_cost_share", emp_cost_share)
    }
    //saved contract if already not exist
    if (!localStorage.getItem("saved_contract")) {
      localStorage.setItem("saved_contract", JSON.stringify([this.getSavedContractObjectReturn(index)]))
      return;
    }
    //saved contract if already exist update this value
    let bool_flag = false;
    let tempArray = JSON.parse(localStorage.getItem("saved_contract"))
    tempArray.map((c_flag, c_index) => {
      if (this.pbm[index].contract_id == c_flag.contract_id) {
        tempArray[c_index] = this.getSavedContractObjectReturn(index)
        bool_flag = true;
      }
    })
    //saved new contract in existing localstorage array
    if (!bool_flag) {
      tempArray.push(this.getSavedContractObjectReturn(index));
    }
    localStorage.setItem("saved_contract", JSON.stringify(tempArray))
  }

  getPBM_data_replace_with_saved_contract = (pbm_data) => {
    if (localStorage.getItem("saved_contract")) {
      let tempArray = JSON.parse(localStorage.getItem("saved_contract"));
      let temp_PBM_Array = pbm_data;

      temp_PBM_Array.map((data, index) => {
        tempArray.map((s_c_data, s_c_index) => {
          if (data.contract_id == s_c_data.contract_id) {
            temp_PBM_Array[index].pma_credit = s_c_data.pma;
            temp_PBM_Array[index].admin_fee = s_c_data.admin;
            data.categories.map((categories_data, categories_index) => {
              s_c_data.categories.map((categories_s_c_data, categories_s_c_index) => {
                if (categories_data.category == categories_s_c_data.category) {
                  temp_PBM_Array[index].categories[categories_index].rebate = categories_s_c_data.rebate;
                  temp_PBM_Array[index].categories[categories_index].discount = categories_s_c_data.discount;
                }
              })
            })
            data.effective_categories.map((categories_data, categories_index) => {
              s_c_data.effective_categories.map((categories_s_c_data, categories_s_c_index) => {
                if (categories_data.effective_categories == categories_s_c_data.effective_categories) {
                  temp_PBM_Array[index].effective_categories[categories_index].rebate = categories_s_c_data.rebate;
                  temp_PBM_Array[index].effective_categories[categories_index].discount = categories_s_c_data.discount;
                }
              })
            })
          }
        })
      })

      this.temp_pbm = this.pbm = temp_PBM_Array;
    }
  }
  @action getPBM = async data => {
    this.pbm = [];
    this.temp_pbm = [];
    try {
      let response = await post(
        `${this.url}/getPBM`,
        data
      );
      if(data.standard) {
        return response.data
      }
      this.pbm = this.temp_pbm = response.data;
      this.getPBM_data_replace_with_saved_contract(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  @action getCategoryDiscountPercentage(index, category_name) {
    const pbm_to_check = JSON.parse(JSON.stringify(this.pbm[index]))

    const category = pbm_to_check[pbm_to_check.use_contracted ? "categories": "effective_categories"][0];
    let discount;
    switch (category_name) {
      case "RG30":
        discount = category["retail_generic_30_discount"]
      case "RB30":
        discount = category["retail_brand_30_discount"]
      case "RB90":
        discount = category["retail_brand_90_discount"]
      case "RG90":
        discount = category["retail_generic_90_discount"]
      case "S":
        discount = category["specialty_discount"]
      case "MB30":
      case "MB90":
        discount = category["mailorder_brand_discount"]
      case "MG30":
      case "MG90":
        discount = category["mailorder_generic_discount"]
    }
    return parseFloat(discount / 100)
  }

  /*MarketTiles Methods */

  @action change_detect_boolean(change) {
    this.title_change = change;
    this.change_detect = change
  }


  @action setDefaultValue = (index) => {
    this.change_detect = false
    this.change_in_card_detect[index] = false
    const target_pbm = JSON.parse(JSON.stringify(this.pbm[index]))
    this.pbm[index] = { ...target_pbm.original_data, original_data: target_pbm.original_data }
  }
  @action onchangeInput = (e, category, flag, index) => {
    this.toggle_change()
    this.change_in_card_detect[index] = true
    const contract = JSON.parse(JSON.stringify(this.pbm[index]));
    let data = contract[contract.use_contracted ? "categories" : "effective_categories"];
    for (let i in data) {
      if (data[i].category == category) {
        if (flag == "reprice_claim_rebate") {
          data[i][get_rebate_key(contract)] = e
        }
        else {
          data[i][get_discount_key(contract)] = e
        }
      }
    }
    this.pbm[index][contract.use_contracted ? "categories" : "effective_categories"] = data;
  }
  @action returnAWP = (c) => {
    let awp = "";
    if (this.toggle) {
      awp = c?.current_awp ?? 0;
    }
    else {
      awp = c.awp;
    }
    return ((awp) * (1 - c.discount / 100)) + Number(c.mac_awp);
  }





  @action changeAdmin_fee = (e, index) => {
    this.toggle_change()
    this.change_in_card_detect[index] = true
    let data = JSON.parse(JSON.stringify(this.pbm[index][this.pbm[index]?.use_contracted?"admin_fee":"effective_admin_fee"]));
    data = e;
    this.pbm[index][this.pbm[index]?.use_contracted?"admin_fee":"effective_admin_fee"] = data;
  }
  @action changePma_credit = (e, index) => {
    this.toggle_change()
    if (isNaN(e)) {
      e = 0
    }
    this.change_in_card_detect[index] = true
    let data = JSON.parse(JSON.stringify(this.pbm[index][this.pbm[index]?.use_contracted?"pma_credit":"effective_pma_credit"]));
    data = e;
    this.pbm[index][this.pbm[index]?.use_contracted?"pma_credit":"effective_pma_credit"] = data;
  }

  @action return_category_total_all = (inflation, index) => {
    let data = JSON.parse(JSON.stringify(this.pbm[index]));
    let use_effective = data.is_current && !data.use_contracted ? true : false
    if (data[use_effective ? "effective_categories" : "categories"].length > 0) {
      return data[use_effective ? "effective_categories" : "categories"].reduce((a, b) => a + this.return_category_total(inflation, b, use_effective), 0)
    }
  }
  @action return_category_total = (inflation, b, use_effective=false) => {
    let discount_field = 'discount'
    let div = 100
    if(use_effective) {
      discount_field = 'ACTUAL_DISCOUNT'
      // div=1
    }
    return this.return_with_inflation(inflation, parseFloat(b["awp"]) * (1 - Number(b[discount_field]) / div)) + this.return_with_inflation(inflation, Number(b["mac_awp"]))
  }

  @action return_total_dispensing_fee_non_current = (data) => {
    return data["contracted_dispensing_fee"]
    // return data.categories.reduce((a, b) => a + b['dispensing_fee'] * Number(b['claims_count']), 0)
  }

  @action return_co_pay = (inflation, index, co_pay_share) => {
    let data = JSON.parse(JSON.stringify(this.pbm[index]));
    const use_effective  = data.is_current && !data.use_contracted;
    if (data[use_effective ? "effective_categories" : "categories"].length > 0) {
      if (co_pay_share > 0) {
        return this.return_category_total_all(inflation, index) * (co_pay_share / 100);
      }
      return data[use_effective ? "effective_categories" : "categories"].reduce((a, b) => a + b["reprice_co_pay"] * this.return_category_total(inflation, b, use_effective), 0)
    }
    return 0
  }

  @action return_plan_pay = (inflation, index, co_pay_share) => {
    let data = JSON.parse(JSON.stringify(this.pbm[index]));
    let pma_to_add = 0;
    let admin_fee_to_add = 0;
    if (data[data.use_contracted?"pma_credit":"effective_pma_credit"] > 0) {
      pma_to_add = parseFloat(this.participant_count * data[data.use_contracted?"pma_credit":"effective_pma_credit"]);
    }
    if (data[data.use_contracted?"admin_fee":"effective_admin_fee"] > 0) {
      admin_fee_to_add = parseFloat(data.claims_count * data[data.use_contracted?"admin_fee":"effective_admin_fee"]);
    }
    let dispensing_fee_to_add = !data.use_contracted ? Number(data.effective_dispensing_fee) :this.return_total_dispensing_fee_non_current(data);
    return (this.return_category_total_all(inflation, index) - this.return_co_pay(inflation, index, co_pay_share)) + (admin_fee_to_add) - (pma_to_add) + (dispensing_fee_to_add)
  }

  @action return_total_overall_cost = (inflation, index, co_pay_share) => {

    const data = this.return_plan_pay(inflation, index, co_pay_share) + this.return_co_pay(inflation, index, co_pay_share)
    if(index == this.comparison_index) {
      this.current_pbm_awp = data;
    }
    return data
  }

  @action return_with_admin_fee_and_pma_credit = (number, index) => {
    let data = JSON.parse(JSON.stringify(this.pbm[index]));
    let pma_to_add = 0;
    let admin_fee_to_add = 0;
    if (data.pma_credit > 0) {
      pma_to_add = parseFloat(data.claims_count * data.pma_credit);
    }
    if (data.admin_fee > 0) {
      admin_fee_to_add = parseFloat(data.claims_count * data.admin_fee);
    }
    return number - pma_to_add + admin_fee_to_add;
  }
  @action return_with_inflation = (inflation, number) => {
    if (inflation > 0) {
      return parseFloat(number * (1 + (inflation / 100)));
    }
    return number
  }
  @action discounted_reprice_cost = (inflation, key, index, co_pay_recalculate = false) => {
    let awp = "awp";
    if (this.toggle) {
      awp = "current_awp"
    }
    if (this.pbm.length > 0) {
      let data = JSON.parse(JSON.stringify(this.pbm[index]));
      if (data[data.use_contracted ? "categories" : "effective_categories"].length > 0) {
        if (co_pay_recalculate) {
          return data[data.use_contracted ? "categories" : "effective_categories"].reduce((a, b) => a + parseFloat(this.return_with_inflation(inflation, b[key])), 0)
        }
        if (key == "reprice_co_pay") {
          return data[data.use_contracted ? "categories" : "effective_categories"].reduce((a, b) => a + ((parseFloat(this.return_with_inflation(inflation, b[awp])) + parseFloat(b["mac_reprice_co_pay"])), 0))
        }
        return data[data.use_contracted ? "categories" : "effective_categories"].reduce((a, b) => a + ((parseFloat(this.return_with_inflation(inflation, b[awp])) * (1 - parseFloat(Number(b.discount)) / 100)) + parseFloat(this.return_with_inflation(inflation, b[`mac_${key}`]))), 0)
      }
      return 0
    }
  }
  @action return_cost_with_additives = (co_pay_share, number, type, inflation, index, co_pay_recalculate = false) => {
    if (co_pay_recalculate) {
      return this.discounted_reprice_cost(inflation, "awp", index, co_pay_recalculate);
    }
    if (type == "claim_cost") {
      return this.return_with_admin_fee_and_pma_credit(this.discounted_reprice_cost(inflation, "awp", index), index);
    }
    if (co_pay_share > 0 && type == "co_pay") {
      return (this.return_cost_with_additives(co_pay_share, number, "claim_cost", inflation, index, true) / 100) * parseFloat(co_pay_share);
    }
    if (co_pay_share > 0 && type == "plan_pay") {
      return (this.return_cost_with_additives(co_pay_share, number, "claim_cost", inflation, index) / 100) * parseFloat(100 - co_pay_share);
    }
    if (type == "co_pay")
      return this.discounted_reprice_cost(inflation, "reprice_co_pay", index, true);
    else if (type == "plan_pay") {
      return this.return_with_admin_fee_and_pma_credit(this.discounted_reprice_cost(inflation, "awp", index), index) - this.discounted_reprice_cost(inflation, "reprice_co_pay", index, true);
    }
  }
  /*End Market Tiles Methods*/

  @action setCSVFile = async (data) => {
    this.reportError = "";
    try {
      let response = await post(
        `${this.url}/setCSVFile`,
        data);
      return true
    } catch (err) {
      this.reportError = err.response.data
      console.log(err.response.data);
      return false
    }
  };
  @action getRunIdsByGroups = async data => {
    this.runids_groups = [];
    try {
      let response = await post(
        `${this.url}/getRunIdByGroups`,
        data
      );
      this.runids_groups = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action deleteContract = (index) => {
    if (localStorage.getItem("deleted_contract_by_market_check")) {
      let tempArr = [];
      tempArr = JSON.parse(localStorage.getItem("deleted_contract_by_market_check"));
      tempArr.push(this.pbm[index]);
      localStorage.setItem("deleted_contract_by_market_check", JSON.stringify(tempArr));
      this.delete_contract_dropdown = tempArr;
      this.pbm[index] = null;
      return;
    }
    this.delete_contract_dropdown.push(this.pbm[index]);
    localStorage.setItem("deleted_contract_by_market_check", JSON.stringify([this.pbm[index]]));
    this.pbm[index] = null;
  }

  @action createDeleteContract = (data) => {
    localStorage.setItem("deleted_contract_by_market_check", JSON.stringify(data));
  }

  setRenewalContract(item,isRenewal){
    if(isRenewal && this.contract_name_status){
      item.is_current=0;
      item.use_contracted=1;
      item.original_data.is_current=0;
      item.original_data.use_contracted=1;

      item.full_name=this.custom_contract_name;
      item.original_data.full_name=this.custom_contract_name;

      item.isRenewal=true;
      item.original_data.isRenewal=true;
    }
    return item;
  }
  setRenewalContractCount(items,isRenewal,contractIndex){
    if(!isRenewal){
      return items;
    }

    if(!this.contract_name_status){
      items[contractIndex].original_data.full_name=this.custom_contract_name;
      items[contractIndex].full_name=this.custom_contract_name;
      return items;
    }

    return items;
    // let renewalCount=1;
    // const renewalData=[];
    // for (const [index,iterator] of items.entries()) {

    //   if(iterator?.contract_id==-1 && !iterator?.is_current &&  index>0){

    //     iterator.original_data.full_name=this.pbm[0].original_data.full_name.concat("-","Renewal");
    //     iterator.full_name=this.pbm[0].full_name.concat("-","Renewal");

    //     if(index>1){
    //       iterator.original_data.full_name=iterator.original_data.full_name.concat(" ",renewalCount);
    //       iterator.full_name=iterator.full_name.concat(" ",renewalCount);
    //     }
    //     renewalCount++;
    //   }

    //   renewalData.push(iterator);
    // }
    // return renewalData;
  }

  getIndexToAssignContract(index){
    let getIndex=index;
    while(this.pbm[index]?.contract_id==this.pbm[getIndex+1]?.contract_id && this.pbm[index]?.full_name==this.pbm[getIndex+1]?.full_name){
      getIndex++;
    }
    return getIndex==0?1:getIndex+1;
  }

  @action duplicateContract = (index, item,isRenewal=false) => {
    let data = JSON.parse(JSON.stringify(this.pbm));
    let data_change_in_card_detect = JSON.parse(JSON.stringify(this.change_in_card_detect));

    if(this.contract_name_status || !isRenewal){
      item=this.setRenewalContract(item,isRenewal);
      data.splice(this.getIndexToAssignContract(index), 0, {...item.original_data, original_data:item.original_data});
      data_change_in_card_detect.splice(this.getIndexToAssignContract(index), 0, false);
    }

    this.pbm = this.setRenewalContractCount(data,isRenewal,index);
    this.change_in_card_detect=data_change_in_card_detect;
  }
  @action resetDropDown = () => {
    localStorage.removeItem("deleted_contract_by_market_check")
    this.delete_contract_dropdown = [];
    this.delete_dropdown = false;
  }

  @action DeleteContractAdd = (index) => {
    let tempArr = [];
    this.delete_contract_dropdown = [];
    tempArr = JSON.parse(localStorage.getItem("deleted_contract_by_market_check"));
    this.pbm.push(tempArr[index]);
    let TempArr_2 = [];
    for (var a = 0; a < tempArr.length; a++) {
      if (index != a) {
        TempArr_2.push(tempArr[a]);
      }
    }
    localStorage.setItem("deleted_contract_by_market_check", JSON.stringify(TempArr_2));
    this.delete_contract_dropdown = TempArr_2;
    if (TempArr_2.length == 0) {
      this.delete_dropdown = false;
    }

  }
  @action getPBMCategories = async data => {
    this.pbm_categories = [];
    try {
      let response = await post(
        `${this.url}/getPBMCategories`,
        data
      );

      this.pbm_categories = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action filter_groups = async data => {
    try {
      let response = await post(
        `${this.url}/filter_groups`,
        data
      );

      return response.data
    } catch (err) {
      console.log(err);
    }
  }

  @action createXLSXReport = async (data, with_package = false, isSingle = false) => {
    this.reportError = "";
    try {
      let response = await post(
        `${this.url}/createXLSXReport?with_package=${with_package}&&isSingle=${isSingle}`,
        data
      );

      return true
    } catch (err) {
      this.reportError = err.response.data
      console.log(err);
    }
  };

  @action generateExcludedClaimsCsv = async data => {
    this.reportError = "";
    try {
      let response = await post(
        `${this.url}/generateExcludedClaimsCsv`,
        data
      );

      return true
    } catch (err) {
      this.reportError = err.response.data
      console.log(err);
    }
  };
}
export default MarketCheckStore;
